export default __webpack_public_path__ + "static/logo-j-71afd6779765d1c560a4f240c86da149.png";